import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormControl } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { AuthService } from "src/app/auth/services/auth.service";
import { ConfigService } from "src/app/configurations/services/config.service";
import { MembershipService } from "src/app/membership/services/membership.service";
declare var $: any;

@Component({
  selector: "app-add-edit-family-members",
  templateUrl: "./add-edit-family-members.component.html",
  styleUrls: ["./add-edit-family-members.component.css"],
  providers: [MessageService],
})
export class AddEditFamilyMembersComponent implements OnInit {
  FindPatientForm: any;
  FindAnotherPatientDetails = false;
  familyMembers = [];
  // membershipService: any;
  loader: boolean = false;
  familyMembersList = [];
  @Input() SelectedPatientRecord: any;
  ModalFamilyMemberList: boolean = false;
  NoFamilyMembers: boolean = false;
  isFamilyMemberEdit: boolean = false;
  FamilyMembersArray = [];
  foundPatientList: any;
  isNoFamilyHead = false;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  displayedColumnsPatient = [
    "PatientName",
    "IsPartoffamily",
    "Inthesameaddress",
    "IsFamilyHead",
    "Action",
  ];
  displayedColumnsPatientSearch = ["PatientName", "DOB", "Action"];
  dataSourceSearchFamilyMembers;
  PatientsNotFound: boolean = false;
  didFoundPatients: boolean = false;
  @Input() PatientID;
  familyDetails: any[];
  FamilyMemberData: any[];
  @Input() PatientFamilyGroupIDFromParent: any;
  @Output() updatedFamilyMembers = new EventEmitter<string>();
  isAlreadyPresentInList: boolean = false;
  LogData: any = [];

  constructor(
    public fb: FormBuilder,
    private membershipService: MembershipService,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private configService: ConfigService,
    private auth: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.InitializeFindFamilyPatientForm();
    // this.route.params.subscribe(params => {
    //   this.PatientID = params['PatientID'];
    // })
    this.ShowFamilyMemberDetails(this.PatientID);
  }

  InitializeFindFamilyPatientForm() {
    this.FindPatientForm = this.fb.group({
      FirstName: new FormControl(""),
      LastName: new FormControl(""),
      DOB: new FormControl(""),
      PatientRegID: new FormControl(""),
    });
  }

  getFamilyMembers() {
    this.familyMembers = [];
    this.membershipService.GetLinkedFamilyMembers(this.PatientID).subscribe(
      (res) => {
        if (res["success"]) {
          res["data"] = JSON.parse(this.configService.dec(res["data"]));
          if (res["data"] && res["data"].length > 0) {
            this.familyMembers = res["data"];
          } else {
            this.familyMembers = [];
          }
        } else {
          this.familyMembers = [];
        }
      },
      (err) => {
        this.familyMembers = [];
      }
    );
  }

  pageEventSearchMembers($event) {
    this.dataSourceSearchFamilyMembers.paginator = this.paginator;
  }

  ShowFamilyMemberDetails(patientID) {
    this.InsertLog("Show family members details");
    this.loader = true;
    this.familyMembersList = [];
    this.membershipService
      .GetFamilyMembersByPatientAddress(
        this.PatientID,
        this.PatientFamilyGroupIDFromParent
          ? this.PatientFamilyGroupIDFromParent
          : 0
      )
      .subscribe(
        (res) => {
          if (res["success"]) {
            this.loader = false;
            if (res["data"] && res["data"].length > 0) {
              this.familyMembersList = res["data"];
              this.ModalFamilyMemberList = true;
              this.NoFamilyMembers = false;
            } else {
              this.NoFamilyMembers = true;
              this.familyMembersList = [];
              this.ModalFamilyMemberList = true;
            }
          } else {
            this.loader = false;
            this.NoFamilyMembers = true;
            this.familyMembersList = [];
            this.ModalFamilyMemberList = true;
          }
        },
        (err) => {
          this.loader = false;
          this.NoFamilyMembers = true;
          this.familyMembersList = [];
          this.ModalFamilyMemberList = true;
        }
      );
  }

  AddFamilyMemberArray(row, event) {
    this.isFamilyMemberEdit = true;
    event.target.classList.remove("fa-trash");
    event.target.classList.add("fa-edit");
    event.target.classList.add("disabled");

    if (event.target.classList.contains("fa-minus-circle")) {
      event.target.classList.remove("fa-minus-circle");
      event.target.classList.remove("text-danger");
      event.target.classList.add("fa-plus-circle");
      event.target.classList.add("text-success");
      // for (var i = this.FamilyMembersArray.length - 1; i >= 0; i--) {
      //   if (this.FamilyMembersArray[i].PatientID === row.PatientID) {
      //     this.FamilyMembersArray.splice(i, 1);
      //   }
      // }

      for (var i = this.familyMembersList.length - 1; i >= 0; i--) {
        if (this.familyMembersList[i].PatientID == row.PatientID) {
          this.familyMembersList[i].IsPartOfFamily = 0;
        }
      }
      this.InsertLog(
        "Removed family member " + row.FirstName + " " + row.LastName
      );
      this.familyMembersList = [...this.familyMembersList];
    } else {
      // this.FamilyMembersArray.push({ PatientID: row.PatientID });
      event.target.classList.remove("fa-plus-circle");
      event.target.classList.remove("text-success");
      event.target.classList.add("fa-minus-circle");
      event.target.classList.add("text-danger");

      for (var i = this.familyMembersList.length - 1; i >= 0; i--) {
        if (this.familyMembersList[i].PatientID == row.PatientID) {
          this.familyMembersList[i].IsPartOfFamily = 1;
          this.familyMembersList[i].PatientFamilyGroupID =
            this.PatientFamilyGroupIDFromParent;
        }
      }
      this.InsertLog(
        "Added family member " + row.FirstName + " " + row.LastName
      );
      this.familyMembersList = [...this.familyMembersList];
    }
  }

  // removeFamilymemberArray(row, event) {
  //   if (event.target.classList.contains("fa-plus-circle")) {
  //     event.target.classList.remove("fa-plus-circle");
  //     event.target.classList.remove("text-success");
  //     this.FamilyMembersArray.push({ PatientID: row.PatientID });
  //     this.InsertLog(
  //       "Added family member " + row.FirstName + " " + row.LastName
  //     );
  //   } else {
  //     for (var i = this.FamilyMembersArray.length - 1; i >= 0; i--) {
  //       if (this.FamilyMembersArray[i].PatientID === row.PatientID) {
  //         this.FamilyMembersArray.splice(i, 1);
  //       }
  //     }
  //     this.InsertLog(
  //       "Removed family member " + row.FirstName + " " + row.LastName
  //     );
  //     event.target.classList.add("text-danger");
  //   }
  // }

  findPatientDetails() {
    this.InsertLog(
      "Find patient for adding to family by FirstName" +
        this.FindPatientForm.value.FirstName +
        " LastName " +
        this.FindPatientForm.value.LastName +
        " Ref Num " +
        this.FindPatientForm.value.PatientRegID +
        " DOB " +
        this.FindPatientForm.value.DOB
    );
    this.loader = true;
    this.isAlreadyPresentInList = false;
    var PatientData = {
      FirstName: this.FindPatientForm.value.FirstName,
      LastName: this.FindPatientForm.value.LastName
        ? this.FindPatientForm.value.LastName
        : "",
      PatientRegNumber: this.FindPatientForm.value.PatientRegID
        ? this.FindPatientForm.value.PatientRegID
        : "",
      DOB: this.FindPatientForm.value.DOB ? this.FindPatientForm.value.DOB : "",
    };
    this.membershipService
      .FindPatientByPatientDataForMembership(PatientData)
      .subscribe(
        (res) => {
          if (res["success"]) {
            res["data"] = JSON.parse(this.configService.dec(res["data"]));
            if (res["data"] && res["data"].length > 0) {
              this.loader = false;
              this.foundPatientList = res["data"];
              this.dataSourceSearchFamilyMembers = new MatTableDataSource(
                this.foundPatientList
              );
              setTimeout(() => {
                this.dataSourceSearchFamilyMembers.sort = this.sort;
                this.dataSourceSearchFamilyMembers.paginator = this.paginator;
              }, 1000);
              this.openFoundPatientList();
              this.PatientsNotFound = false;
            } else {
              this.loader = false;
              this.PatientsNotFound = true;
              this.foundPatientList = [];
              this.dataSourceSearchFamilyMembers = [];
            }
          } else {
            this.loader = false;
            this.PatientsNotFound = true;
            this.foundPatientList = [];
            this.dataSourceSearchFamilyMembers = [];
          }
        },
        (err) => {
          this.loader = false;
          this.PatientsNotFound = true;
          this.foundPatientList = [];
          this.dataSourceSearchFamilyMembers = [];
        }
      );
  }

  openFoundPatientList() {
    this.InsertLog("Open found patient list");
    this.didFoundPatients = true;
  }

  FindAnotherPatientDetail() {
    this.InsertLog("Find another patient details");
    this.FindAnotherPatientDetails = true;
  }

  selectedPatient(row) {
    this.InsertLog(
      "On select patient " +
        row.FirstName +
        " " +
        row.LastName +
        " to add as family member"
    );
    var flag;
    for (var i = 0; i < this.familyMembersList.length; i++) {
      if (this.familyMembersList[i].PatientID === row.PatientID) {
        flag = 1;
        break;
      } else {
        flag = 0;
      }
    }

    if (flag === 1) {
      this.isAlreadyPresentInList = true;
      this.foundPatientList = [];
      this.dataSourceSearchFamilyMembers = [];
      this.FindPatientForm.reset();
      this.InitializeFindFamilyPatientForm();
    } else {
      this.isAlreadyPresentInList = false;
      this.isFamilyMemberEdit = true;
      // this.FamilyMembersArray.push({ PatientID: row.PatientID });
      this.familyMembersList.push({
        PatientID: row.PatientID,
        FirstName: row.FirstName,
        LastName: row.LastName,
        IsPartOfFamily: 1,
        IsFamilyHead: $("#" + this.PatientID).prop("checked") ? 1 : 0,
        PatientFamilyGroupID: this.PatientFamilyGroupIDFromParent,
      });
      this.familyMembersList = [...this.familyMembersList];
      // this.FamilyMembersArray = [...this.FamilyMembersArray];
      this.foundPatientList = [];
      this.dataSourceSearchFamilyMembers = [];
      this.FindPatientForm.reset();
      this.InitializeFindFamilyPatientForm();
    }
  }

  cancelFamilyMember() {
    this.familyDetails = [];
    this.FamilyMemberData = [];
    this.familyMembersList = [];
    this.ModalFamilyMemberList = false;
    this.isFamilyMemberEdit = false;
    this.isNoFamilyHead = false;
    this.updatedFamilyMembers.emit("false");
  }

  saveFamilyMember() {
    if (
      this.familyMembersList &&
      this.familyMembersList.length > 0 &&
      this.isFamilyMemberEdit
    ) {
      if ($("input[name='IsFamilyHead']:checked").length > 0) {
        var flag = 0;
        for (var i = 0; i < this.familyMembersList.length; i++) {
          if (
            this.familyMembersList[i].IsPartOfFamily === 0 &&
            this.familyMembersList[i].IsFamilyHead === 1
          ) {
            flag = 1;
            break;
          } else {
            flag = 0;
          }
        }
        if (flag === 0) {
          this.isNoFamilyHead = false;
          const newRef = this;
          $("input[name='IsFamilyHead']").each(function (i) {
            newRef.familyMembersList.forEach((element) => {
              if (element.PatientID === $(this).val()) {
                element.IsFamilyHead = $(this).prop("checked") ? 1 : 0;
              }
            });
          });
          this.loader = true;
          if (
            this.familyMembersList &&
            this.familyMembersList.length > 0 &&
            this.isFamilyMemberEdit
          ) {
            var PrimaryPatientID = this.PatientID;
            var patientData = JSON.stringify(this.familyMembersList);
            var PatientFamilyGroupID = this.PatientFamilyGroupIDFromParent
              ? this.PatientFamilyGroupIDFromParent
              : 0;
            var IsFamilyHead = $("#" + PrimaryPatientID).prop("checked")
              ? 1
              : 0;
            this.membershipService
              .InsertPatientFamilyLink(
                PatientFamilyGroupID,
                this.familyMembersList,
                PrimaryPatientID,
                IsFamilyHead
              )
              .subscribe(
                (res) => {
                  if (res["success"]) {
                    this.loader = false;
                    this.ShowToast(
                      "success",
                      "Success!!",
                      "Family members have been saved successfully."
                    );
                    this.ModalFamilyMemberList = false;
                    this.familyMembersList = [];
                    this.familyMembers = [];
                    this.loader = false;
                    this.isFamilyMemberEdit = false;
                    this.updatedFamilyMembers.emit("true");
                  } else {
                    this.familyMembersList = [];
                    this.familyMembers = [];
                    this.loader = false;
                    this.isFamilyMemberEdit = false;
                    this.ModalFamilyMemberList = false;
                    this.updatedFamilyMembers.emit("false");
                    this.ShowToast(
                      "warn",
                      "Warning",
                      "Unable to save family members details. Please try again."
                    );
                  }
                },
                (err) => {
                  this.familyMembersList = [];
                  this.familyMembers = [];
                  this.loader = false;
                  this.isFamilyMemberEdit = false;
                  this.ModalFamilyMemberList = false;
                  this.updatedFamilyMembers.emit("false");
                  this.ShowToast(
                    "error",
                    "Error",
                    "Unable to save family members details. Please try again."
                  );
                }
              );
          } else {
            this.familyMembersList = [];
            // this.FamilyMembersArray = [];
            this.familyMembers = [];
            this.loader = false;
            this.isFamilyMemberEdit = false;
          }
        } else {
          this.isNoFamilyHead = true;
          this.loader = false;
        }
      } else {
        this.isNoFamilyHead = true;
        this.loader = false;
      }
    } else {
      this.ModalFamilyMemberList = false;
      this.familyMembersList = [];
      this.familyMembers = [];
      this.loader = false;
      this.isFamilyMemberEdit = false;
      this.updatedFamilyMembers.emit("false");
    }
  }

  ShowToast(type, title, desc) {
    this.messageService.add({
      severity: type,
      summary: title,
      detail: desc,
    });
  }

  InsertLog(ButtonName) {
    if (this.router.url.startsWith("/membership")) {
      this.LogData.push({
        Notes: ButtonName,
        DateTime: new Date(),
        StaffName: this.auth.staffName,
      });
      localStorage.setItem("LogData", JSON.stringify(this.LogData));
    }
  }

  isChangeFamilyHead(event, patientID, patientName) {
    this.InsertLog("On Family Head Change to " + patientName);
    this.isFamilyMemberEdit = true;
    if (patientID !== this.PatientID) {
      this.familyMembersList.forEach((element) => {
        if (element.PatientID === patientID) {
          element.IsFamilyHead = 1;
        } else {
          element.IsFamilyHead = 0;
        }
      });
    }
    this.isNoFamilyHead = false;
  }
}
